// react
import * as React from "react";
import * as ReactDOM from "react-dom";
// local
import {Guide} from "./components/Guide";
import {StepData} from "./StepData";
import {Observable} from 'diy/util/Observable';
import {computeSidebarWidth} from "./components/Sidebar";
import {computeContentWidth} from "./components/Content";

interface ResponsiveParams {
    tabletView: boolean;
}

export interface ServerInitData {
    steps: StepData[];
    isCompleted: boolean;
    firstUncompletedStep: string;
}

const TABLE_VIEW_BREAKPOINT = 810;
const CONTAINER_HEIGHT = 590;

/**
 * Maps viewport width upper limit to params
 *
 * !! Keys should be in ascending order
 */
const responsiveParamMap = new Map<number, ResponsiveParams>()
    .set(TABLE_VIEW_BREAKPOINT, {
        tabletView: true,

    })
    .set(Number.MAX_VALUE, {
        tabletView: false
    })
;

export default class OnboardingGuide {
    private steps: StepData[] = [];
    private currentStepPosition = 0;
    private rootElement: HTMLElement;
    private isVisible = false;
    private responsiveParams: ResponsiveParams;
    private showSidebar = true;

    constructor(private observable: Observable, private $window: JQuery, private onClose?: () => void ) {
    }

    setElement(contentElement: HTMLElement) {
        this.rootElement = contentElement;
    };

    setData(serverData: ServerInitData) {
        this.steps = serverData.steps;
        this.currentStepPosition = 0;

        if (serverData.isCompleted) {
            this.selectLastVisibleStep();
        } else {
            this.selectStep(serverData.firstUncompletedStep);
        }
    }

    setStep(stepName: string) {
        this.selectStep(stepName);
        this.update();
    }

    setSidebar(shown: boolean) {
        if (shown !== this.showSidebar) {
            this.$window.trigger('resize.saWindowSizeBehavior');
        }
        this.showSidebar = shown;
        this.update();
    }

    setVisible() {
        if (!this.isVisible) {
            this.$window.on('resize.onboardingGuide', () => {
                this.update();
            });
            this.observable.notify({
                eventName: 'diy-editor-onboardingGuide-open',
                step: this.steps[this.currentStepPosition]
            });
        }
        this.isVisible = true;
        this.update();
    }

    setHidden() {
        if (this.isVisible) {
            this.$window.off('.onboardingGuide');
        }
        this.isVisible = false;
    }

    getWindowSize() {
        this.updateResponsiveParams();
        return {
            width: computeContentWidth(this.responsiveParams.tabletView)
                + (this.showSidebar
                    ? computeSidebarWidth(this.responsiveParams.tabletView)
                    : 0
                ),
            height: CONTAINER_HEIGHT
        };
    };

    private close(step: StepData) {
        this.observable.notify({
            eventName: 'diy-editor-onboardingGuide-close',
            step: step
        });
        if (this.onClose) {
            this.onClose();
        }
    };

    private updateResponsiveParams() {
        let targetWidth = this.$window.width();
        this.responsiveParams = Array.from(responsiveParamMap).find(
            ([viewportWidth]) => (targetWidth < viewportWidth)
        )[1];
    };

    private update() {
        this.updateResponsiveParams();
        if (this.rootElement) {
            ReactDOM.render(
                <Guide steps={this.steps}
                       onClose={(step) => this.close(step)}
                       observable={this.observable}
                       initialStep={this.steps[this.currentStepPosition]}
                       showSidebar={this.showSidebar}
                       tabletView={this.responsiveParams.tabletView}
                />,
                this.rootElement
            );
        }
    }

    private selectStep(stepId: string) {
        for (let i = 0; i < this.steps.length; i++) {
            if (this.steps[i].id === stepId) {
                this.currentStepPosition = i;
                return;
            }
        }
    };

    private selectLastVisibleStep() {
        for (let i = this.steps.length; i >= 0; i--) {
            if (!this.steps[i].hidden) {
                this.currentStepPosition = i;
            }
        }
    };

};



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/site-admin/onboarding-guide/OnboardingGuide.tsx
 **/